import { Component, EventEmitter, Inject, Input, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { NgForm } from '@angular/forms';
import { AppState } from '../../../store';
import { BaseForm, BaseFormInterface } from '../../../common/base/base-form.component';
import { MarketingCloudConnection } from '../../connection.models';
import { NotifyService } from '../../../common/services/notify.service';
import { selectConnectionsErrors } from '../../store/connections.selectors';

@Component({
  selector: 'connection-form-marketing-cloud',
  template: `
    <xp-form-validation type="MarketingCloudConnection" [name]="formName">
      <form id="connectionFormMarketingCloud" name="connectionFormMarketingCloud" #form="ngForm" class="form">
        <div class="row">
          <div class="col-md-6">
            <xp-form-group>
              <label for="name">{{ 'connections.form.labels.name' | translate }}</label>
              <xp-input
                type="text"
                class="form-control"
                name="name"
                id="name"
                [(ngModel)]="connection.name"
                placeholder=""
              ></xp-input>
            </xp-form-group>
            <div class="form-group" *ngIf="connection.unique_id">
              <label for="unique_id">{{ 'connections.form.labels.unique_id' | translate }}</label>
              <xp-input
                type="text"
                class="form-control"
                name="unique_id"
                id="unique_id"
                [(ngModel)]="connection.unique_id"
                [attr.readonly]="true"
                [readOnly]="true"
              ></xp-input>
            </div>
          </div>
          <div class="col-md-6">
            <xp-form-group>
              <label for="client_id">{{ 'connections.form.marketing_cloud.labels.client_id' | translate }}</label>
              <xp-input
                type="text"
                class="form-control"
                name="client_id"
                id="client_id"
                [(ngModel)]="connection.client_id"
              ></xp-input>
            </xp-form-group>
            <xp-form-group>
              <label for="client_secret">{{
                'connections.form.marketing_cloud.labels.client_secret' | translate
              }}</label>
              <xp-input
                type="password"
                class="form-control"
                name="client_secret"
                id="client_secret"
                [(ngModel)]="connection.client_secret"
              ></xp-input>
            </xp-form-group>
            <xp-form-group>
              <label for="subdomain">{{ 'connections.form.marketing_cloud.labels.subdomain' | translate }}</label>
              <xp-input
                type="text"
                class="form-control"
                name="subdomain"
                id="subdomain"
                [(ngModel)]="connection.subdomain"
              ></xp-input>
            </xp-form-group>
            <xp-form-group>
              <label for="account_id">{{ 'connections.form.marketing_cloud.labels.account_id' | translate }}</label>
              <xp-input
                type="text"
                class="form-control"
                name="account_id"
                id="account_id"
                [(ngModel)]="connection.account_id"
              ></xp-input>
            </xp-form-group>
          </div>
        </div>
      </form>
    </xp-form-validation>
  `,
})
export class ConnectionFormMarketingCloudComponent extends BaseForm implements BaseFormInterface {
  @Input() connection: Partial<MarketingCloudConnection> = {};
  @Output() formValidationChange = new EventEmitter<boolean>();

  @ViewChild('form') form: NgForm;
  formName = 'connectionFormMarketingCloud';
  successMessageText = 'connection.form.success_message';
  errors$ = this.store.select(selectConnectionsErrors);
  errorTexts = [];

  constructor(
    protected store: Store<AppState>,
    protected notify: NotifyService,
    protected translate: TranslateService,
    @Inject('$rootScope') private $rootScope: any,
  ) {
    super();
  }
}
